module.exports = __webpack_public_path__ + "img/streaming-icon.e851265d.svg";